export default __webpack_public_path__ + "static/media/gridImage16.60b0f73e.png";